import {
  EXTENSION_URL,
  INSURANCE_PROGRAMS_ADDITIONAL_INFORMATION,
  INSURANCE_PROGRAMS_COUNTRY,
  INSURANCE_PROGRAMS_ENROLLMENT_CODE,
  INSURANCE_PROGRAMS_PLAN_IDENTIFIER,
} from '@constants/extension-codes';

import type { InsuranceValues } from '@models/insurance';

import { formatPatientId } from '@utils/format';

import type { CoverageModelInput, Extension } from 'generated/types';
import { CoverageStatus } from 'generated/types';

export function getCoverageTemplate(
  patient_id: string,
  values: InsuranceValues
): CoverageModelInput {
  const extensionFields: Extension[] = [];
  if (values.planIdentifier) {
    extensionFields.push({
      url: `${EXTENSION_URL}${INSURANCE_PROGRAMS_PLAN_IDENTIFIER}`,
      valueString: values.planIdentifier,
    });
  }
  if (values.enrollmentCode) {
    extensionFields.push({
      url: `${EXTENSION_URL}${INSURANCE_PROGRAMS_ENROLLMENT_CODE}`,
      valueString: values.enrollmentCode,
    });
  }
  if (values.country) {
    extensionFields.push({
      url: `${EXTENSION_URL}${INSURANCE_PROGRAMS_COUNTRY}`,
      valueString: values.country,
    });
  }
  if (values.additionalInformation) {
    extensionFields.push({
      url: `${EXTENSION_URL}${INSURANCE_PROGRAMS_ADDITIONAL_INFORMATION}`,
      valueString: values.additionalInformation,
    });
  }

  return {
    resourceType: 'Coverage',
    status: CoverageStatus.active,
    subscriberId: values.planNumber,
    beneficiary: {
      reference: formatPatientId(patient_id),
    },
    subscriber: {
      reference: formatPatientId(patient_id),
    },
    payor: [
      {
        display: values.provider,
      },
    ],
    period: {
      start: values.issueDate,
      end: values.expirationDate,
    },
    extension: extensionFields,
  };
}
